import * as React from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Box, Container } from "@mui/material";
import hypnosis from "../../images/hypnosis.png";
import counselling from "../../images/counselling.webp";
import awarness from "../../images/awarness.png";
import insomnia from "../../images/insomnia.webp";
import meditation from "../../images/meditation.png";
import scienceofyoga from "../../images/scienceofyoga.jpg"
import { useNavigate } from "react-router-dom";

const styles = {
  parentCard: {
    border: "1px solid",
    borderColor: "grey.300",
    borderRadius: "10px",
    width: "30%", // Set width to make them equal size

    mb: 4,
    display: "flex", // Make card a flexbox container
    flexDirection: "column", // Ensure that card content and media are stacked vertically
    height: "400px", // Set a fixed height for uniformity
  },
  parentBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    flexWrap: "wrap",
    gap: "40px", // Add some gap between the cards
  },
  cardTitle: {
    fontFamily: "poppins",
    fontWeight: "bold",
  },
  cardSubtitle: {
    fontFamily: "poppins",
    fontSize: "15px",
    overflow: "hidden", // Make sure the subtitle doesn't overflow
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 2, // Limit to 2 lines of text
    WebkitBoxOrient: "vertical",
    opacity: 0.7,
  },
  button: {
    px: "10px",
    py: "5px",
    fontFamily: "poppins",
    fontSize: "14px",
    textTransform: "none",
    backgroundColor: "#141414FF",
    color: "#ffffff",
    mb: 1,
  },
};

const cardContents = [
  {
    id: 1,
    img: hypnosis,
    cardTitle: "Private Hypnotherapy & Past Life Regression Sessions",
    cardSubTitle:
      "Ready to overcome stress, anxiety, or emotional challenges? Our private in-person hypnotherapy and past life regression sessions help you access your subconscious, uncover root causes, and achieve lasting clarity and healing.",
    path: "/privateHypnotherapy",
  },
  {
    id: 2,
    img: counselling,
    cardTitle: "Personal Counselling",
    cardSubTitle:
      "In counseling we provide personal attention by listening to your problem and to draw the best solution to whatever problems you are going through.",
    path: "/personalCounselling",
  },
  {
    id: 3,
    img: awarness,
    cardTitle: "Understanding Awareness: A Journey Within",
    cardSubTitle:
      "Awareness, a term often used interchangeably with consciousness, is the fundamental human capacity to perceive, feel, and think.",
    path: "/awareness",
  },
  {
    id: 4,
    img: insomnia,
    cardTitle: "What is insomnia? Causes, Cures, Remedies",
    cardSubTitle:
      "People with an abundance of money are luxurious, they have properties, but they are unable to buy sleep in their life.",
    path: "/insomnia",
  },
  {
    id: 5,
    img: meditation,
    cardTitle: "What is Meditation?",
    cardSubTitle:
      "Meditation means to simply be. That is to be aware of the present moment and what is going on.",
    path: "/medidation",
  },
  {
    id: 6,
    img: scienceofyoga,
    cardTitle: "The science of Yoga?",
    cardSubTitle:
      "Here our body and mind is a continuous communication and communion with one another. The body speaks to the mind and vice versa also. Thus keeping this basic logic in mind we can approach in two ways either first go from the mind to the body or from the body to the mind.",
    path: "/scienceOfYoga",
  },
];

const YogaCards = () => {
  const navigate = useNavigate();
  return (
    <Container maxWidth="lg" id="yoga-cards-section">
      {" "}
      {/* Add the id to target it */}
      <Box sx={styles.parentBox}>
        {cardContents.map((item) => (
          <Card sx={styles.parentCard} elevation={0} key={item.id}>
            <CardMedia
              sx={{ height: 200, objectFit: "cover" }}
              image={item.img}
              title="Card Image"
            />
            <CardContent sx={{ flexGrow: 1 }}>
              <Typography
                gutterBottom
                variant="h5"
                component="div"
                sx={styles.cardTitle}
              >
                {item.cardTitle}
              </Typography>
              <Typography variant="body2" sx={styles.cardSubtitle}>
                {item.cardSubTitle}
              </Typography>
            </CardContent>
            <CardActions sx={{ display: "flex", justifyContent: "center" }}>
              <Button
                size="small"
                sx={styles.button}
                onClick={() => navigate(item.path)}
              >
                View More
              </Button>
            </CardActions>
          </Card>
        ))}
      </Box>
    </Container>
  );
};

export default YogaCards;
